import { ComplaintReception } from "types";
import apiClient from "../lib/apiClients";

// COMPLAINT
export const fetchComplaintReception = async () => {
  const response = await apiClient.get<ComplaintReception[]>(
    "/complaint_entity/complaints/"
  );
  return response.data;
};
export const fetchComplaintReceptionByOrgAndAdminUnit = async (
  admin_unit: string | number,
  org_unit: string | number,
  isRegistrar: boolean = false
) => {
  const url = isRegistrar
    ? `/complaint_entity/complaints/filter_by_unit/?admin_unit_id=${admin_unit}`
    : `/complaint_entity/complaints/filter_by_unit/?admin_unit_id=${admin_unit}&org_unit_id=${org_unit}`;
  const response = await apiClient.get<ComplaintReception[]>(url);
  return response.data;
};
export const fetchComplaintByClientId = async (clientId: string | number) => {
  const response = await apiClient.get<ComplaintReception[]>(
    `/complaint_entity/complaints/by-client-id/?client_id=${clientId}`
  );
  return response.data;
};
export const fetchComplaintReceptionById = async (id: number | string) => {
  const response = await apiClient.get<ComplaintReception>(
    "/complaint_entity/complaints/" + id + "/"
  );
  return response.data;
};
export const addComplaintReception = async (complaint: ComplaintReception) => {
  const response = await apiClient.post(
    "/complaint_entity/complaints/",
    complaint
  );
  return response.data;
};
export const editComplaintReception = async (complaint: any) => {
  const response = await apiClient.patch(
    "/complaint_entity/complaints/" + complaint?.id + "/",
    complaint
  );
  return response.data;
};
export const deleteComplaintReception = async (
  complaint: ComplaintReception
) => {
  const response = await apiClient.delete(
    "/complaint_entity/complaints/" + complaint?.id + "/"
  );
  return response.data;
};
